import React from 'react'

/**
 * ChatBotIcon icon
 * @constructor
 */
export const ChatBotIcon = () => (
  <svg
    fill="none"
    height="60"
    viewBox="0 0 60 60"
    width="60"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      fill="url(#paint0_linear_12988_93309)"
      height="60"
      rx="12"
      width="60"
    />
    <path
      d="M33.2891 19.7039C33.34 20.0989 33.3937 20.4938 33.4361 20.8916C33.5068 21.5212 33.4984 21.5155 34.0018 21.152C34.7315 20.6331 35.465 20.1189 36.2023 19.6095C36.3493 19.5064 36.42 19.4349 36.3295 19.2231C36.2275 18.9932 36.1748 18.7439 36.1748 18.4919C36.1748 18.2398 36.2275 17.9906 36.3295 17.7607C36.3887 17.6021 36.481 17.4584 36.6002 17.3393C36.7193 17.2203 36.8625 17.1287 37.0199 17.0708C37.1773 17.0129 37.3452 16.9901 37.5121 17.0039C37.679 17.0178 37.841 17.068 37.9869 17.1511C38.8156 17.5403 39.2456 18.8196 38.8185 19.6209C38.7356 19.8034 38.6091 19.9623 38.4506 20.0832C38.2921 20.2041 38.1063 20.2833 37.9101 20.3136C37.7138 20.344 37.5132 20.3246 37.3262 20.2571C37.1392 20.1896 36.9717 20.0763 36.8386 19.9271C36.6491 19.7325 36.5417 19.7068 36.3267 19.8957C35.4782 20.6426 34.6297 21.4325 33.8321 22.2424C33.7902 22.2822 33.7605 22.3332 33.7465 22.3895C33.7324 22.4458 33.7347 22.5051 33.7529 22.5601C34.4091 25.4364 35.515 28.1094 37.3279 30.4562C38.6462 32.1551 40.2794 33.5774 42.1361 34.6432C42.7357 34.9895 43.358 35.3014 44 35.6076C43.8004 35.714 43.5857 35.7883 43.3636 35.828C42.0898 36.208 40.7687 36.4008 39.4407 36.4004C37.8031 36.3661 36.3041 35.9396 35.0851 34.7691C34.1883 33.8701 33.5457 32.7446 33.224 31.5094C32.6216 29.4745 32.5226 27.3825 32.6074 25.2761C32.6329 24.6579 32.6725 24.0397 32.7064 23.3844C32.4464 23.5964 32.2042 23.83 31.9824 24.0827C29.3753 26.6824 26.8993 29.4132 24.5636 32.2649C23.1281 33.9905 21.8554 35.8484 20.7623 37.8142C20.2345 38.7499 19.8529 39.7626 19.631 40.8163C19.4792 41.4981 19.5254 42.2097 19.7639 42.8655C19.7775 42.9093 19.787 42.9544 19.7922 43C18.6156 42.8283 17.4956 42.5879 16.6527 41.6778C16.0192 40.9995 15.9485 40.161 16.0248 39.2938C16.1465 37.8628 16.7574 36.6179 17.5154 35.4359C18.7726 33.572 20.2527 31.8725 21.9219 30.376C23.8069 28.6354 25.784 26.9998 27.8445 25.4764C29.4312 24.283 31.0518 23.1411 32.6866 22.0249C32.7472 21.9895 32.7984 21.9398 32.8359 21.88C32.8733 21.8202 32.8959 21.7521 32.9016 21.6815C32.9949 21.0233 33.108 20.3679 33.2127 19.7125L33.2891 19.7039Z"
      fill="white"
    />
    <path
      d="M30.8458 27.0474C30.6478 27.7686 30.4102 28.4783 30.2151 29.1909C29.9035 30.2603 29.7491 31.3702 29.7569 32.485C29.7965 33.9904 30.2433 35.3212 31.4539 36.2857C32.3173 36.9275 33.3236 37.3443 34.384 37.4991C34.8662 37.5897 35.3537 37.6481 35.8435 37.6737C35.6667 37.7922 35.4688 37.8748 35.2608 37.917C33.8834 38.4015 32.4625 38.7485 31.0183 38.953C30.0086 39.0732 29.0017 39.1132 28.0344 38.7097C27.0671 38.3062 26.6202 37.5649 26.5184 36.5547C26.3742 35.181 26.7843 33.9188 27.3273 32.6939C28.1558 30.912 29.1785 29.2292 30.3763 27.677C30.5347 27.4681 30.6902 27.2563 30.8458 27.0474Z"
      fill="white"
    />
    <defs>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        id="paint0_linear_12988_93309"
        x1="6.30769"
        x2="29.1804"
        y1="-1.44958"
        y2="64.9374"
      >
        <stop stopColor="#AFA4D0" />
        <stop offset="0.317708" stopColor="#4474CD" />
        <stop offset="1" stopColor="#3452A4" />
      </linearGradient>
    </defs>
  </svg>
)
